export enum EMenuButtonItemType {
  BUTTON,
  LINK
}

export enum EMenuItemPosition {
  ABOVE,
  BELOW,
  BEFORE,
  AFTER
}

export interface IMenuButtonItem {
  type: EMenuButtonItemType;
  label: string;
  getLabel?: (target: any) => string;
  route?: any[];
  getRoute?: (target: any) => any[];
  onClick?: (target?: any) => void;
  disabled?: boolean;
  getDisabled?: (target: any) => boolean;
  class?: string;
  isShown?: (target: any) => boolean;
}

export interface IMenuButtonProperties {
  items: IMenuButtonItem[];
  position?: EMenuItemPosition;
}
